import { Injectable } from '@nestjs/common';
import { Logs } from '../logs.entity';
import { LogsDTO } from './logs.dto';

@Injectable()
export class LogsAdapter {

  public convertDtoToEntity(newlogs: LogsDTO, isUpdate: boolean = false): Logs {
    const logs = new Logs();
    logs.logId = newlogs.logId;
    logs.tableName = newlogs.tableName;
    logs.operationName = newlogs.operationName;
    logs.rowId = newlogs.rowId;
    logs.displayValue = newlogs.displayValue;
    logs.previousValue = newlogs.presentValue;
    logs.presentValue = newlogs.presentValue;
    logs.status = newlogs.status;
    logs.createdUser = newlogs.createdUser;
    return logs;
  }

  public convertEntityToDto(log: Logs): LogsDTO {
    const newlogsDTO = new LogsDTO;
    log.logId = newlogsDTO.logId;
    log.tableName = newlogsDTO.tableName;
    log.operationName = newlogsDTO.operationName;
    log.rowId = newlogsDTO.rowId;
    log.displayValue = newlogsDTO.displayValue;
    log.previousValue = newlogsDTO.presentValue;
    log.presentValue = newlogsDTO.presentValue;
    log.status = newlogsDTO.status;
    log.createdUser = newlogsDTO.createdUser;
    log.versionFlag = newlogsDTO.versionFlag;
    return log;
  }
}
